<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-SheDengXin12`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_2bd44b2bfe__clip0_1290_3785)"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.07065 2.78418C3.5736 2.78418 3.17065 3.18712 3.17065 3.68418C3.17065 4.18124 3.5736 4.58418 4.07065 4.58418H7.79469L9.15994 7.3489C6.53021 9.07536 5.59039 12.5497 7.08218 15.3937L10.1408 21.2248L9.96469 21.3194C9.52676 21.5545 9.36236 22.1001 9.59749 22.5381C9.83261 22.976 10.3782 23.1404 10.8162 22.9053L22.1913 16.7979C22.6293 16.5627 22.7937 16.0171 22.5585 15.5792C22.3234 15.1413 21.7778 14.9769 21.3399 15.212L21.0468 15.3693L18.0437 9.64403C16.6445 6.97643 13.5729 5.75361 10.7915 6.58762L9.80219 4.58418H13.756C14.2531 4.58418 14.656 4.18124 14.656 3.68418C14.656 3.18712 14.2531 2.78418 13.756 2.78418H4.07065ZM9.79725 8.63951L10.605 10.2752C10.825 10.7208 11.3647 10.9037 11.8104 10.6836C12.2561 10.4636 12.439 9.92386 12.2189 9.47818L11.43 7.88059C13.497 7.36568 15.7243 8.3045 16.7577 10.2747L19.7853 16.0467L11.4517 20.521L8.38176 14.6682C7.27503 12.5583 7.91975 9.99433 9.79725 8.63951Z"/></g><defs><clipPath id="svg_2bd44b2bfe__clip0_1290_3785"><path transform="translate(.918 .898)" d="M0 0H24V24H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconSheDengXin12',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
